module.exports = __webpack_public_path__ + "img/zpt2.7021e458.svg";